import { Button, Dropdown } from '@teo/components';
import { Document, Image, Play, Ai } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import { TheoSearch } from '@teo/components/illustrations';
import { Video } from '@/components/Froala/widgets/ChatGPT/Icon/index';

const ExtraInfoEmpty = ({
  handleNewExtraIndo,
  handleOpenLibrary,
  fileInputRef,
  setIsOpenVideoModal,
  setIsOpenLibraryModal,
  startInstruction,
  startAiExtraInfoLesson,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex py-8">
        <TheoSearch className="m-auto w-32" />
      </div>
      <p className="px-3 text-sm text-grey-07">{t('extra_info.text_empty')}</p>
      <div className="my-5 flex justify-center gap-3">
        <Dropdown>
          <Dropdown.Trigger>
            <Button>{t('extra_info.btn_add_info')}</Button>
          </Dropdown.Trigger>
          <Dropdown.Content
            style={{
              top: '25px',
              left: '0',
            }}
          >
            <Dropdown.Actions>
              <Dropdown.Button
                onClick={() => {
                  handleNewExtraIndo();
                }}
              >
                <Document className="m-2 mr-4 h-5 w-5 text-grey-07" />
                <p className="text-sm">{t('extra_info.new_lesson')}</p>
              </Dropdown.Button>

              {startAiExtraInfoLesson && (
                <Dropdown.Button onClick={startAiExtraInfoLesson}>
                  <Ai className="m-2 mr-4 h-5 w-5 text-tint-blue" />
                  <p className="text-sm">
                    {t('pages.ai_document_job_modal.create_extra_info_title')}
                  </p>
                </Dropdown.Button>
              )}

              <Dropdown.Button
                onClick={() => {
                  handleOpenLibrary();
                }}
              >
                <Document className="m-2 mr-4 h-5 w-5 text-secondary-04" />
                <p className="text-sm">{t('extra_info.les_library')}</p>
              </Dropdown.Button>
              <Dropdown.Button onClick={() => setIsOpenLibraryModal(true)}>
                <Image className="m-2 mr-4 h-5 w-5 text-grey-07" />
                <p className="text-sm">{t('extra_info.upload_img')}</p>
              </Dropdown.Button>
              <Dropdown.Button
                onClick={() => {
                  setIsOpenVideoModal(true);
                }}
              >
                <Play className="m-2 mr-4 h-5 w-5 text-grey-07" />
                <p className="text-sm">{t('extra_info.upload_video')}</p>
              </Dropdown.Button>

              <Dropdown.Button
                onClick={() => {
                  startInstruction();
                }}
              >
                <Video className={`m-2 mr-4 h-5 w-5 text-grey-07`} />
                <p>
                  {t(
                    'pages.create_edit_course.video_instruction.instructional_video'
                  )}
                </p>
              </Dropdown.Button>
            </Dropdown.Actions>
          </Dropdown.Content>
        </Dropdown>
        <Button
          variant="outline"
          onClick={() => {
            fileInputRef.current?.click();
          }}
        >
          {t('extra_info.btn_upload')}
        </Button>
      </div>
    </>
  );
};

export default ExtraInfoEmpty;
